// ----------------------------------------------------------------------------
// Template: Account
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';

// Styles
import './_account.scss';
